import React, { useState, useEffect } from 'react';
import {
    Row, Col, Form, Label, Input, Card, CardBody,
    Container, Button, FormFeedback
} from "reactstrap";
import Flatpickr from "react-flatpickr";
import { toast } from "react-toastify";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { useNavigate } from "react-router-dom";
import InputMask from "react-input-mask";

const AneesVoucherCreate = () => {
    const [voucher, setVoucher] = useState('');
    const [title, setTitle] = useState('');
    const [repeatations, setRepeatations] = useState(1);
    const [amount, setAmount] = useState('');
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(null);

    const navigate = useNavigate();

    const [validation, setValidation] = useState({
        title: null,
        startDate: null,
        endDate: null,
        repeatations: null,
        amount: null,
        voucher: null,
    });

    const validateFields = () => {
        let isValid = true;
        const newValidation = {};

        const voucherPattern = /^[A-Z]{3}-\d{3}-[A-Z0-9]{5}$/;

        newValidation.title = title.trim() !== '';
        newValidation.voucher = voucher.trim() !== '' && voucherPattern.test(voucher.trim());
        newValidation.repeatations = repeatations >= 1;
        newValidation.amount = amount !== '' && amount >= 0;
        newValidation.startDate = startDate && new Date(startDate) >= new Date().setHours(0, 0, 0, 0);
        if (!endDate) {
            newValidation.endDate = false;
        } else if (startDate && new Date(endDate) <= new Date(startDate)) {
            newValidation.endDate = false;
        } else {
            newValidation.endDate = true;
        }
        // newValidation.endDate = endDate && startDate && new Date(endDate) > new Date(startDate);

        setValidation(newValidation);

        Object.values(newValidation).forEach(v => {
            if (v !== true) isValid = false;
        });

        return isValid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateFields()) return;

        const payload = {
            title,
            start_date: startDate?.toISOString().split('T')[0],
            end_date: endDate?.toISOString().split('T')[0],
            repeatations,
            amount,
            voucher_code: voucher
        };

        try {
            const token = localStorage.getItem("authToken");
            const response = await fetch(`${process.env.REACT_APP_WEB_APP_URL}/api/web/anees-vouchers/create`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
                body: JSON.stringify(payload),
            });

            const data = await response.json();

            if (response.status === 200) {
                toast.success('Voucher created successfully', { autoClose: 3000 });

                navigate(`/anees-vouchers`);
            } else if (response.status === 422) {
                if (data?.errors) {
                    Object.values(data.errors).forEach((errorArr) => {
                        errorArr.forEach((errMsg) => {
                            toast.error(errMsg, { autoClose: 3000 });
                        });
                    });
                } else {
                    toast.error(data?.message || 'Validation failed', { autoClose: 3000 });
                }
            } else {
                toast.error(data?.message || `Error: ${response.statusText}`, { autoClose: 3000 });
            }
        } catch (err) {
            console.log(err);
            toast.error("Failed to create voucher", { autoClose: 3000 });
        }
    };

    document.title = "Add Anees Voucher | Moeen";

    return (
        <div className="page-content">
            <Container fluid={true}>
                <Breadcrumbs maintitle="Home" title="Add Anees Voucher" />

                <Row>
                    <Col lg={12}>
                        <Card>
                            <CardBody>
                                <Form onSubmit={handleSubmit}>
                                    <Row>
                                        <Col md="6">
                                            {/* Title */}
                                            <div className="mb-3">
                                                <Label>Title</Label>
                                                <Input
                                                    type="text"
                                                    placeholder="Enter title"
                                                    value={title}
                                                    onChange={e => setTitle(e.target.value)}
                                                    valid={validation["title"] === true}
                                                    invalid={validation["title"] !== true && validation["title"] !== null}
                                                />
                                                <FormFeedback tooltip>Title is required.</FormFeedback>
                                            </div>

                                            {/* Start Date */}
                                            <div className="mb-3">
                                                <Label>Start Date</Label>
                                                <Flatpickr
                                                    className={`form-control ${validation["startDate"] === false ? 'is-invalid' : validation["startDate"] === true ? 'is-valid' : ''}`}
                                                    value={startDate}
                                                    placeholder="Select Start Date"
                                                    options={{
                                                        altInput: true,
                                                        altFormat: "F j, Y",
                                                        dateFormat: "Y-m-d",
                                                        minDate: "today"
                                                    }}
                                                    onChange={(dates) => setStartDate(dates[0])}
                                                />
                                                {validation["startDate"] === false && (
                                                    <div className="invalid-tooltip d-block">Start date must be today or later.</div>
                                                )}
                                            </div>

                                            {/* End Date */}
                                            <div className="mb-3">
                                                <Label>End Date</Label>
                                                <Flatpickr
                                                    className={`form-control ${validation["endDate"] === false ? 'is-invalid' : validation["endDate"] === true ? 'is-valid' : ''}`}
                                                    value={endDate}
                                                    placeholder="Select End Date"
                                                    options={{
                                                        altInput: true,
                                                        altFormat: "F j, Y",
                                                        dateFormat: "Y-m-d",
                                                        minDate: startDate
                                                    }}
                                                    onChange={(dates) => setEndDate(dates[0])}
                                                />
                                                {validation["endDate"] === false && (
                                                    <div className="invalid-tooltip d-block">End date must be after start date.</div>
                                                )}
                                            </div>
                                        </Col>

                                        <Col md="6">
                                            {/* Repeatations */}
                                            <div className="mb-3">
                                                <Label>Repeatations</Label>
                                                <Input
                                                    type="number"
                                                    value={repeatations}
                                                    onChange={e => setRepeatations(Number(e.target.value))}
                                                    placeholder="Enter repeatation"
                                                    min="1"
                                                    valid={validation["repeatations"] === true}
                                                    invalid={validation["repeatations"] !== true && validation["repeatations"] !== null}
                                                />
                                                <FormFeedback tooltip>Repeatations must be at least 1.</FormFeedback>
                                            </div>

                                            {/* Amount */}
                                            <div className="mb-3">
                                                <Label>Amount</Label>
                                                <Input
                                                    type="number"
                                                    value={amount}
                                                    onChange={e => setAmount(Number(e.target.value))}
                                                    placeholder="Enter amount"
                                                    min="0"
                                                    valid={validation["amount"] === true}
                                                    invalid={validation["amount"] !== true && validation["amount"] !== null}
                                                />
                                                <FormFeedback tooltip>Amount must be a positive number.</FormFeedback>
                                            </div>

                                            {/* Voucher Code */}
                                            <div className="mb-3">
                                                <Label>
                                                    Voucher Code
                                                    <small className="text-muted ms-2 d-none d-md-inline">
                                                        <i
                                                            id="voucherInfo"
                                                            className="ti-info-alt text-muted me-1"
                                                            aria-hidden="true"
                                                        />
                                                        Format: <code>XXX-000-XX000</code>
                                                    </small>
                                                </Label>
                                                <InputMask
                                                    mask="aaa-999-*****"
                                                    maskChar={null}
                                                    formatChars={{
                                                        'a': '[A-Za-z]',
                                                        '9': '[0-9]',
                                                        '*': '[A-Za-z0-9]',
                                                    }}
                                                    placeholder="XXX-000-XX000"
                                                    value={voucher}
                                                    onChange={(e) => setVoucher(e.target.value.toUpperCase())}
                                                >
                                                    {(inputProps) => (
                                                        <Input
                                                            {...inputProps}
                                                            required
                                                            valid={validation["voucher"] === true}
                                                            invalid={validation["voucher"] !== true && validation["voucher"] !== null}
                                                        />
                                                    )}
                                                </InputMask>

                                                {validation["voucher"] === false && (
                                                    <div className="invalid-tooltip d-block">
                                                        Voucher format must be <strong>XXX-000-XX000</strong>
                                                    </div>
                                                )}
                                            </div>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col className="text-end">
                                            <Button type="submit" color="primary">
                                                Submit
                                            </Button>
                                        </Col>
                                    </Row>
                                </Form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default AneesVoucherCreate;
